/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Shortcut_Keys_Save_Project_Error_ToastInputs */

const en_shortcut_keys_save_project_error_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Save project completed with error. ${i?.error}`)
};

const fr_shortcut_keys_save_project_error_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enregistrement du projet termine avec erreur. ${i?.error}`)
};

const de_shortcut_keys_save_project_error_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projekt mit Fehler gespeichert. ${i?.error}`)
};

const it_shortcut_keys_save_project_error_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Salvataggio del progetto completato con errore. ${i?.error}`)
};

const ru_shortcut_keys_save_project_error_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сохранение проекта завершилось с ошибкой. ${i?.error}`)
};

const es_shortcut_keys_save_project_error_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guardar proyecto completado con error. ${i?.error}`)
};

const zh_cn2_shortcut_keys_save_project_error_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`项目保存失败。${i?.error}`)
};

const ja_shortcut_keys_save_project_error_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクトの保存がエラーで完了しました。${i?.error}`)
};

const hi_shortcut_keys_save_project_error_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट सेव करने में त्रुटि आई। ${i?.error}`)
};

const pt_pt2_shortcut_keys_save_project_error_toast = /** @type {(inputs: Shortcut_Keys_Save_Project_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projeto salvo concluído com erro. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Save project completed with error. {error}" |
*
* @param {Shortcut_Keys_Save_Project_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_save_project_error_toast = /** @type {((inputs: Shortcut_Keys_Save_Project_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Save_Project_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_save_project_error_toast(inputs)
	if (locale === "de") return de_shortcut_keys_save_project_error_toast(inputs)
	if (locale === "it") return it_shortcut_keys_save_project_error_toast(inputs)
	if (locale === "ru") return ru_shortcut_keys_save_project_error_toast(inputs)
	if (locale === "es") return es_shortcut_keys_save_project_error_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_save_project_error_toast(inputs)
	if (locale === "ja") return ja_shortcut_keys_save_project_error_toast(inputs)
	if (locale === "hi") return hi_shortcut_keys_save_project_error_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_save_project_error_toast(inputs)
	return en_shortcut_keys_save_project_error_toast(inputs)
});